import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const analyst1 = defineConnector({
  identifier: "analyst1",
  name: "Analyst1",
  tagLine: "Threat intelligence platform",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://[^/]*\\.analyst1\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In your Analyst1 instance, navigate to your account settings to generate an API key.",
        },
      ],
    },
    {
      title: "Enter your Analyst1 details",
      items: [
        {
          kind: "baseUrl",
          label: "Base URL",
          placeholder: "https://your-instance.analyst1.com",
          required: true,
          target: { kind: "configuration", field: "baseUrl" },
          helperText: "Your Analyst1 instance URL.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => `${baseUrl}/api/1_0/system/status`,
  },
  publicEnvVars: ({ baseUrl }) => ({
    ANALYST1_URL: baseUrl || "",
  }),
});
